export const SERVER_LANG = {
    "zh-hans": "zh-TW",
    "zh-hant": "zh-TW",
    zh: "zh-TW",
    en: "en-US",
    ja: "ja-JP",
};
